import whatIsCfdTradingContent from "./content/what-is-cfd-trading.json";

export const whatIsCfdTradingMock = {
  name: "what-is-cfd-trading",
  layoutType: 1,
  areasList: [
    {
      id: "what-is-cfd-trading-1",
      name: "what-is-cfd-trading-content",
      componentName: "Comp:WhatIsCfdTradingPage",
      content: JSON.stringify(whatIsCfdTradingContent),
    },
  ],
};
